import { useSearchParams } from 'react-router'

export function useEditInvitedCompanyNameModal() {
  const [searchParams, setSearchParams] = useSearchParams(
    window.location.search,
  )

  const companyName = searchParams.get(
    EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.companyName,
  )

  const source = searchParams.get(
    EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.source,
  )

  const sourceId = searchParams.get(
    EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.sourceId,
  )

  return {
    companyName,
    source,
    sourceId,

    showModal: ({
      companyName,
      source,
      sourceId,
    }: {
      companyName: string
      source: string
      sourceId: number
    }) => {
      searchParams.set(
        EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.companyName,
        companyName,
      )

      searchParams.set(
        EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.source,
        source,
      )

      searchParams.set(
        EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS.sourceId,
        sourceId.toString(),
      )

      setSearchParams(searchParams)
    },

    hideModal: () => {
      Object.values(EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS).forEach(
        (paramKey) => {
          searchParams.delete(paramKey)
        },
      )

      setSearchParams(searchParams)
    },
  }
}

const prefix = 'editInvitedCompanyNameModal.'

export const EDIT_INVITED_COMPANY_NAME_MODAL_SEARCH_PARAMS = {
  companyName: `${prefix}companyName`,
  source: `${prefix}source`,
  sourceId: `${prefix}sourceId`,
}
